import {TLogin, TRegister, TReset, TValidateRegister} from "./types"
import {store} from './redux/store'

let apiUrl = ''
let lang = ''

store.subscribe(() => {
  apiUrl = store.getState().reducer.baseUrl
  apiUrl += store.getState().reducer.baseUrl === 'https://surfe.be' ? '/react-api/auth' : '/react/auth'
  lang = store.getState().reducer.lang
})

const setCommonData = (pass: string, captcha: string) => {
  const data = new FormData()

  data.append('password', pass)
  data.append('timezone_offset', new Date().getTimezoneOffset().toString())
  data.append('g-recaptcha-response', captcha)
  data.append('dev-captcha', '0')
  data.append('token', localStorage.getItem('authToken') || '')
  data.append('language', lang)

  return data
}

export const userLogin = (
  {
    login,
    password,
    gRecaptchaResponse,
  }: TLogin
) => {
  const data = setCommonData(password, gRecaptchaResponse)

  data.append('login', login)

  return fetch(`${apiUrl}/login`, {
    method: 'post',
    body: data
  }).then(res => res.json())
}

export const userRegister = (
  {
    email,
    login,
    password,
    gRecaptchaResponse
  }: TRegister
) => {
  const data = setCommonData(password, gRecaptchaResponse)

  data.append('login', login)
  data.append('email', email)

  return fetch(`${apiUrl}/reg`, {
    method: 'post',
    body: data
  }).then(res => res.json())
}

export const userPassRequest = ({email}: { email: string }) => {
  const data = new FormData()

  data.append('email', email)
  data.append('token', localStorage.getItem('authToken') || '')
  data.append('language', lang)

  return fetch(`${apiUrl}/pass-request`, {
    method: 'post',
    body: data
  }).then(res => res.json())
}

export const userPassReset = ({uid, key, password}: TReset) => {
  const data = new FormData()

  data.append('uid', uid)
  data.append('key', key)
  data.append('password', password)
  data.append('language', lang)

  return fetch(`${apiUrl}/pass-reset`, {
    method: 'post',
    body: data
  }).then(res => res.json())
}

export const validateRegisterForm = (
  {
    email,
    login,
    gRecaptchaResponse,
    devCaptcha,
    language
  }: TValidateRegister
) => {
  const data = new FormData()

  data.append('email', email)
  data.append('username', login)
  data.append('g-recaptcha-response', gRecaptchaResponse)
  data.append('dev-captcha', devCaptcha)
  data.append('language', language)

  return fetch(`${apiUrl}/reg-check`, {
    method: 'post',
    body: data
  }).then(res => res.json())
}

export const getSurfeToken = () => {
  return fetch(`${apiUrl}/login-surfebe`)
    .then(res => res.json())
}

export const checkIsGuest = () => {
  const data = new FormData()

  data.append('token', localStorage.getItem('authToken') || '')

  return fetch(`${apiUrl}/is-guest`, {
    method: 'post',
    body: data
  }).then(res => res.json())
}

export const getProProfile = (token: string) => {
  const data = new FormData()

  data.append('token', token)

  return fetch(`${store.getState().reducer.baseUrl}/api/user/profile`, {
    method: 'post',
    body: data
  }).then(res => res.json())
}

export const codeSend = (type: string) => {
  const data = new FormData()

  data.append('type', type)
  data.append('token', localStorage.getItem('authToken') || '')

  return fetch(`${store.getState().reducer.baseUrl}/api/2fauth/code/send`, {
    method: 'post',
    body: data
  }).then(res => res.json())
}

export const codeCheck = (type: string, code: string) => {
  const data = new FormData()

  data.append('type', type)
  data.append('token', localStorage.getItem('authToken') || '')
  data.append('code', code)

  return fetch(`${store.getState().reducer.baseUrl}/api/2fauth/code/check`, {
    method: 'post',
    body: data
  }).then(res => res.json())
}


